import { isNil } from 'lodash-es';
import useEffect from '@/util/hook/useEffect';
import useState from '@/util/hook/useState';
import { CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP, } from '../../config/error';
import { MAX_AGE, MAX_HEIGHT, MAX_NOTES_LENGTH, MAX_WEIGHT, MIN_AGE, MIN_HEIGHT, MIN_WEIGHT, } from '../../config/form';
const getIsFieldError = ({ errorTypes }) => (field) => {
    const errorType = CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP[field];
    return errorTypes.includes(errorType);
};
const addErrorType = ({ errorTypes, setErrorTypes, }) => (errorType) => {
    if (errorTypes.includes(errorType))
        return;
    setErrorTypes((prev) => [...prev, errorType]);
};
const removeErrorType = ({ setErrorTypes, }) => (errorType) => {
    setErrorTypes((prev) => prev.filter((type) => type !== errorType));
};
const useHandleFieldError = ({ fieldValue, isError, fieldErrorType, errorTypes, setErrorTypes, }) => {
    useEffect(() => {
        if (isError) {
            addErrorType({ errorTypes, setErrorTypes })(fieldErrorType);
        }
        else {
            removeErrorType({ setErrorTypes })(fieldErrorType);
        }
    }, [fieldValue]);
};
export const useValidateCareOrderBabyForm = ({ contactName, contactGender, contactPhone, contactEmail, gender, height, weight, age, hospitalBed, requiredGender, lang, notes, }) => {
    const [errorTypes, setErrorTypes] = useState([]);
    // contactName
    useHandleFieldError({
        fieldValue: contactName,
        isError: !isNil(contactName) && !contactName,
        fieldErrorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.contactName,
        errorTypes,
        setErrorTypes,
    });
    // contactGender
    useHandleFieldError({
        fieldValue: contactGender,
        isError: !isNil(contactGender) && !contactGender,
        fieldErrorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.contactGender,
        errorTypes,
        setErrorTypes,
    });
    // contactPhone
    useHandleFieldError({
        fieldValue: contactPhone,
        isError: !isNil(contactPhone) && (!contactPhone || !/^09[0-9]{8}$/.test(contactPhone)),
        fieldErrorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.contactPhone,
        errorTypes,
        setErrorTypes,
    });
    // contactEmail
    useHandleFieldError({
        fieldValue: contactEmail,
        isError: false,
        fieldErrorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.contactEmail,
        errorTypes,
        setErrorTypes,
    });
    // gender
    useHandleFieldError({
        fieldValue: gender,
        isError: !isNil(gender) && !gender,
        fieldErrorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.gender,
        errorTypes,
        setErrorTypes,
    });
    // height
    useHandleFieldError({
        fieldValue: height,
        isError: !isNil(height) && (!height || height < MIN_HEIGHT || height > MAX_HEIGHT),
        fieldErrorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.height,
        errorTypes,
        setErrorTypes,
    });
    // weight
    useHandleFieldError({
        fieldValue: weight,
        isError: !isNil(weight) && (!weight || weight < MIN_WEIGHT || weight > MAX_WEIGHT),
        fieldErrorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.weight,
        errorTypes,
        setErrorTypes,
    });
    // age
    useHandleFieldError({
        fieldValue: age,
        isError: !isNil(age) && (!age || age < MIN_AGE || age > MAX_AGE),
        fieldErrorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.age,
        errorTypes,
        setErrorTypes,
    });
    // hospitalBed
    useHandleFieldError({
        fieldValue: hospitalBed,
        isError: !isNil(hospitalBed) && !hospitalBed,
        fieldErrorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.hospitalBed,
        errorTypes,
        setErrorTypes,
    });
    // requiredGender
    useHandleFieldError({
        fieldValue: requiredGender,
        isError: !isNil(requiredGender) && !requiredGender,
        fieldErrorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.requiredGender,
        errorTypes,
        setErrorTypes,
    });
    // lang
    useHandleFieldError({
        fieldValue: lang,
        isError: !isNil(lang) && !lang,
        fieldErrorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.lang,
        errorTypes,
        setErrorTypes,
    });
    // notes
    useHandleFieldError({
        fieldValue: notes,
        isError: !isNil(notes) && notes.length > MAX_NOTES_LENGTH,
        fieldErrorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.notes,
        errorTypes,
        setErrorTypes,
    });
    return {
        errorTypes,
        setErrorTypes,
        getIsFieldError: getIsFieldError({ errorTypes }),
        removeErrorType: removeErrorType({ setErrorTypes }),
    };
};
